export class DslParseError extends Error {
    position;
    constructor(message, position) {
        super(message);
        this.position = position;
        this.name = 'DslParseError';
    }
}
export class DslEvaluateError extends Error {
    constructor(message) {
        super(message);
        this.name = 'DslEvaluateError';
    }
}
export class HostCapabilityError extends Error {
    capability;
    constructor(capability) {
        super(`Missing required capability: ${capability}`);
        this.capability = capability;
        this.name = 'HostCapabilityError';
    }
}
//# sourceMappingURL=errors.js.map